export default __webpack_public_path__ + "static/media/instagram.b3e6b531.svg";